module.exports = __webpack_public_path__ + "static/media/createPhoneNumber_succeeded.fe17f1ed.svg";